(function () {
	'use strict';
	var templateUrl = require('./trash.template');
	angular
		.module('smb-app')
		.directive('smbTrash', [
			TrashDirective
		])
		.controller('TrashController', [
			'$q',
			'$mdDialog',
			'pxProgressSerivce',
			'settingsService',
			'sbToastService',
			'smbToolbarService',
			'smbDeletedItemsDataStore',
			'gettextCatalog',
			TrashController
		]);

	function TrashDirective() {
		return {
			restrict: 'E',
			controller: TrashController,
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: true,
			scope: {}
		};
	}

	function TrashController($q, $mdDialog, pxProgressService, settingsService, sbToastService, smbToolbarService, smbDeletedItemsDataStore, gettextCatalog) {
		var vm = this;
		var initTasks = [
			smbDeletedItemsDataStore.load()
		];
		vm.deletedItemsDS = smbDeletedItemsDataStore;
		vm.purge = purge;
		vm.restore = restore;
		vm.purgeAll = purgeAll;
		smbToolbarService.reset();
		smbToolbarService.showLogo = false;
		smbToolbarService.title = gettextCatalog.getString('System Trash');

		setLoading(true);
		$q.all(initTasks)
			.finally(setLoading(false));
		
		function purge(event, item) {
			var confirm = $mdDialog.confirm()
				.title(gettextCatalog.getString('Delete'))
				.textContent(gettextCatalog.getString('Would you like to permanently delete "{{name}}"?', {
					name: item.name
				}))
				.ariaLabel(gettextCatalog.getString('Confirm permanent document deletion'))
				.targetEvent(event)
				.ok(gettextCatalog.getString('Permanently Delete'))
				.cancel(gettextCatalog.getString('Cancel'));

			$mdDialog
				.show(confirm)
					.then(function () {
					smbDeletedItemsDataStore
						.purge(item)
						.then(function () {
							sbToastService.showSimple(gettextCatalog.getString('Successfully deleted'));
					})
					.catch(function () {
							sbToastService.showSimple(gettextCatalog.getString('Unable to purge item'));
					});
			}, angular.noop);
		}

		function purgeAll(event) {
			var confirm = $mdDialog.confirm()
				.title(gettextCatalog.getString('Empty Trash'))
				.textContent(gettextCatalog.getString('Would you like to empty the trash? All documents in the trash will be permanently deleted.'))
				.ariaLabel(gettextCatalog.getString('Confirm emptying trash'))
				.targetEvent(event)
				.ok(gettextCatalog.getString('Empty Trash'))
				.cancel(gettextCatalog.getString('Cancel'));

			$mdDialog
				.show(confirm)
				.then(function () {
					smbDeletedItemsDataStore
						.purgeAll()
					.then(function () {
							sbToastService.showSimple(gettextCatalog.getString('Trash was emptied'));
					})
					.catch(function () {
							sbToastService.showSimple(gettextCatalog.getString('Unable to empty trash'));
					});

			}, angular.noop);
		}

		function restore(item) {
			smbDeletedItemsDataStore
				.restore(item)
				.then(function () {
					sbToastService.showSimple(gettextCatalog.getString('Successfully restored'));
				})
				.catch(function () {
					sbToastService.showSimple(gettextCatalog.getString('Unable to restore document'));
				});
		}

		function setLoading(isLoading) {
			isLoading = typeof(isLoading) === 'boolean' ? isLoading : false;
			pxProgressService.visible = isLoading;
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/components/trash/trash.js
// module id = 99
// module chunks = 1